// src/routes/OrderAssignmentRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Order Assignment Components
import AssignmentRulesConfigPage from '../pages/orderAssignment/AssignmentRulesConfigPage';
import ManualOrderAssignmentPage from '../pages/orderAssignment/ManualOrderAssignmentPage';
import MyWorkQueuePage from '../pages/orderAssignment/MyWorkQueuePage';

const OrderAssignmentRoutes = () => {
  return (
    <Routes>
      {/* Assignment Rules Configuration */}
      <Route 
        path="/rules" 
        element={
          <PermissionRoute requiredPermission="manage_assignment_rules">
            <AssignmentRulesConfigPage />
          </PermissionRoute>
        } 
      />
      
      {/* Manual Order Assignment */}
      <Route 
        path="/manual" 
        element={
          <PermissionRoute requiredPermission="assign_orders">
            <ManualOrderAssignmentPage />
          </PermissionRoute>
        } 
      />
      
      {/* My Work Queue */}
      <Route 
        path="/my-queue" 
        element={
          <PermissionRoute requiredPermission="view_work_queue">
            <MyWorkQueuePage />
          </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default OrderAssignmentRoutes;